<template>
  <div
    v-if="price"
    class="details-price-container margin-bottom-m"
  >
    <div
      v-if="price.priceType?.text"
      class="price-type-container label"
    >
      <span>{{ price.priceType?.text }}</span>
    </div>

    <div
      v-if="price.priceType?.giftPriceLabelToAllUpcs"
      class="label"
    >
      {{ price.priceType?.giftPriceLabelToAllUpcs }}
    </div>

    <div class="price-tiers">
      <div
        v-for="tieredPrice in price.tieredPrice"
        :key="tieredPrice.id"
        class="tiered-price price"
        :class="{'red bold' : tieredPrice.isOverlayPriceStyled}"
      >
        {{ tieredPrice.label }} {{ tieredPrice.values[0]?.formattedValue }}
        <span
          v-if="(tieredPrice === price.tieredPrice[price.tieredPrice.length - 1])
            && tieredPrice.values[0]?.percentOff?.[0]"
          class="price"
          :class="{ 'red': !price.flags?.isWithOfferPromo }"
        >
          <span> ({{ tieredPrice.values[0]?.percentOff?.[0] }}% off) </span>
          <span
            v-if="price.priceType?.saleEnds"
            class="price gray "
          >{{ price.priceType?.saleEnds }}
          </span>
        </span>
      </div>
    </div>
    <div class="red medium">
      <span>{{ price.offers?.withOffer?.formattedFinalPrice }}</span>
    </div>
    <div
      v-if="price.nonGiftPromotionMessage"
      class="margin-top-xs price"
    >
      {{ price.nonGiftPromotionMessage }}
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { PRICE_OVERLAY_DATA } from './constants';

const price = inject(PRICE_OVERLAY_DATA);
</script>

<style scoped lang="scss">
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.price-type-container {
  display: flex;
}
.price {
  @include body(regular);
}
.red {
  color: $promotions-color;
}
.gray {
  color: $gray-1-color;
}
.bold {
  font-weight: 500;
}
</style>
